<template>
  <AppModal @close="onClose()" v-bind="$attrs" v-if="visible">
    <template v-slot:header>Add Network IDT Number</template>
    <form @submit.prevent="onSubmit()">
      <b-alert v-if="currentNetworkIDTNumber && currentNetworkIDTNumber !== null" variant="warning" show>
        A Network IDT number already exists. Adding a new one will overwrite the existing number.<br>The current Network IDT number is {{ currentNetworkIDTNumber }}
      </b-alert>

      <div class="form-group">
        <label for="networkIDTNumber">Network IDT Number</label>
        <input
          :class="{'is-invalid': $v.networkIDTNumber.$invalid && isValidating}"
          class="form-control" 
          v-model="networkIDTNumber" 
        />
        <transition name="fade">
          <AppNotification type="danger" v-if="!$v.networkIDTNumber.required && isValidating">
            Field is required
          </AppNotification>
        </transition>
      </div>
    </form>

    <template v-slot:footer>
      <button :disabled="isSubmitting" @click.prevent="onSubmit()" class="btn btn-primary" type="submit">
        Submit
      </button>
      <button :disabled="isSubmitting" @click="onClose()" class="btn btn-danger" type="button">
        Close
      </button>
    </template>
  </AppModal>
</template>

<script>
import AppNotification from "@/components/shared/AppNotification";
import AppModal from "@/components/shared/AppModal";
import NetworkIDTService from "@/services/NetworkIDTsService";
import { required } from "vuelidate/lib/validators";
import { ToastType } from "@/services/models/shared/ToastType";

export default {
  components: {
    AppNotification,
    AppModal
  },
  data() {
    return {
      networkIDTNumber: null,
      isSubmitting: false,
      isValidating: false
    };
  },
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false,
    },
    currentNetworkIDTNumber: {
      type: String,
      required: false
    }
  },
  methods: {
    async onSubmit() {
      this.isValidating = true;
      
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.isSubmitting = true;
      NetworkIDTService.createNetworkIDTNumber(this.networkIDTNumber)
        .then(() => {
          this.alert(ToastType.Success, "Network IDT Number added successfully");
          this.onClose();
        })
        .catch(() => {
          this.alert(ToastType.Danger, "Unable to add network IDT number");
        })
        .finally(() => {
          this.resetModal();
        });
    },

    resetModal() {
      this.networkIDTNumber = null;
      this.isValidating = false;
      this.isSubmitting = false;
    },

    onClose() {
      this.resetModal();
      this.$emit("close");
    }
  },
  validations: {
    networkIDTNumber: {
      required
    }
  }
};
</script>